import * as React from 'react';
import * as _ from 'lodash';

export interface IAlphabetFilterProps {
    header: string,
    categoryTheme: string,
    currentSelection: string,
    availableLetters: Array<string>,
    onChangeHandler(letter: string): void
}

export class AlphabetFilter extends React.Component<IAlphabetFilterProps, {}>{

    private alphabet: string[];

    constructor(props: IAlphabetFilterProps) {
        super(props);        
        this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
    }

    private getClassName(letter: string): string {
        let className = 'filters-category-full-item ' + this.props.categoryTheme;
        if (letter === this.props.currentSelection)
            className = className.concat(' active');
        if (this.props.availableLetters.indexOf(letter) === -1)
            className = className.concat(' disabled');
        return className;
    }

    render() {
        return (
            <div className="filters-category-full filters-alpha">
                <h6 className="filters-category-full-heading">{this.props.header}</h6>
                <div className="filters-category-full-container">
                    {this.alphabet.map((x) =>
                        <span key={x} className={this.getClassName(x)} onClick={() => this.props.onChangeHandler(x)}>
                            {x.toUpperCase()}
                        </span>
                    )}
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/alphabet-filter.tsx